import { message } from 'antd';
import { useMutation, useQueryClient } from 'react-query';
import { getQueryKeys } from '../../../../queries/queryKeys';
import { useSelector } from 'react-redux';
import request from '../../../../../../helpers/request';

const chnageConfigurationLSReg = async ({
  houses,
  registrationType,
  arrearTypeIds,
  accessTypeId,
  // arrearProviderIds,
}) => {
  const body = houses.map((house) => ({
    houseId: house,
    registrationTypeId: registrationType.id,
    arrearTypeIds,
    accessTypeId,
    // arrearProviderIds,
  }));

  const res = await request.post(
    `/HousingStock/houses/configuration`,
    JSON.stringify({ configurations: body }),
    'Не удалось изменить тип регистрации',
    'Error',
    undefined,
    {}
  );
  return res;
};

const useConfigurationLSReg = () => {
  const queryClient = useQueryClient();

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const mutation = useMutation(chnageConfigurationLSReg, {
    onSuccess: async (data, { houses, registrationType }) => {
      if (data !== 'Error' && data[0].isSuccess) {
        message.success('Тип регистрации успешно изменен', 2);
        queryClient.setQueryData(
          getQueryKeys.housingStockHouses({ companyId: currentCompany?.id }),
          (oldData) =>
            oldData.map((oldHouse) => {
              const updateHouse = houses.find(
                (houseId) => houseId === oldHouse.houseId
              );
              return updateHouse ? { ...oldHouse, registrationType } : oldHouse;
            })
        );
      }
    },
  });

  return {
    changeAsync: mutation.mutateAsync,
    loading: mutation.isLoading,
  };
};

export { useConfigurationLSReg };
